// extracted by mini-css-extract-plugin
export default {"columnSpace":"CalculationSettings_columnSpace__WKHMm","wrongSoilLayers":"CalculationSettings_wrongSoilLayers__uE-ZT","p":"CalculationSettings_p__FXL-5"};